export default "__VITE_ASSET__DrA75vSn__"